import { render } from "./EspecificacionesMapa.vue?vue&type=template&id=7d27c738&scoped=true"
import script from "./EspecificacionesMapa.vue?vue&type=script&lang=js"
export * from "./EspecificacionesMapa.vue?vue&type=script&lang=js"

import "./EspecificacionesMapa.vue?vue&type=style&index=0&id=7d27c738&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d27c738"]])

export default __exports__